module.exports = __webpack_public_path__ + "static/img/yidun-s.4addba6.png";


//////////////////
// WEBPACK FOOTER
// ./static/compress-img/public/customer/yidun-s.png
// module id = 0pby
// module chunks = 1